import { Fragment, useContext, useMemo } from 'react'

import { Button } from '@hhgtech/hhg-components'
import { useIntl } from 'react-intl'

import { getHelloSitesUrl } from 'api/utils/paths'
import { redirectToSSOWithReturnUrl } from 'api/utils/redirects'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { TogetherPost } from 'interfaces/types'
import { AppContext } from 'state/appContext'

// import { CardPostContent } from '../embededCommunity/postContent'
import { Post } from './components/post'
import { StyledPostSection } from './index.styled'

type PostSectionProps = {
  posts?: TogetherPost[]
  isJoined?: boolean
  communitySlug?: string
  hideButton?: boolean
}

export const PostSection = ({
  posts,
  isJoined,
  communitySlug,
  hideButton = false,
}: PostSectionProps) => {
  const {
    state: { isLoggedIn },
  } = useContext(AppContext)
  const { locale } = useRouterExtend()

  const { formatMessage: f } = useIntl()
  const showJoinCommunity = useMemo(() => !isLoggedIn || !isJoined, [
    isLoggedIn,
    isJoined,
  ])

  if (!posts) return null

  const joinDiscussion = () => {
    window.open(
      `${getHelloSitesUrl(locale)}/community/${communitySlug}`,
      '_blank',
    )
  }

  const joinCommunity = () => {
    redirectToSSOWithReturnUrl(
      `${getHelloSitesUrl(
        locale,
      )}/community/on-boarding/?returnUrl=/${communitySlug}`,
      'communities',
      'embeddedarticle',
      communitySlug,
    )
  }

  return (
    <StyledPostSection>
      {posts.slice(0, 3).map((post, index) => (
        <Fragment key={post.id}>
          <Post post={post} communitySlug={communitySlug} />
          {index !== 2 && <hr />}
        </Fragment>
      ))}
      {!hideButton && (
        <>
          {showJoinCommunity ? (
            <Button
              color="secondary"
              isBlock
              size="lg"
              onClick={joinCommunity}
              className="join pointer-event-child-none"
              data-event-category="Together"
              data-event-action="Join Community"
              data-event-label={`${getHelloSitesUrl(
                locale,
              )}/community/${communitySlug}`}
            >
              {f({
                id: 'together.embed.topicCard.joinNow',
                defaultMessage: 'Join Community',
              })}
            </Button>
          ) : (
            <Button
              color="secondary"
              isBlock
              size="lg"
              onClick={joinDiscussion}
              className="join pointer-event-child-none"
              data-event-category="Together"
              data-event-action="Join Discussion"
              data-event-label={`${getHelloSitesUrl(
                locale,
              )}/community/${communitySlug}`}
            >
              {f({
                id: 'together.embed.topicCard.joinDiscussion',
                defaultMessage: 'Join Discussion',
              })}
            </Button>
          )}
        </>
      )}
    </StyledPostSection>
  )
}
